import { AxiosError } from 'axios';
import { useCustomMutation } from '../utils/useCustomMutation';
import axiosClient from '../axiosClient';
import { PUT_ADD_ADDITIONAL_DOCUMENTS_PROFILE_AMENDMENT_REQUEST_URL } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface AddAdditionalDocumentsRequest {
  fileKeys: string[];
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

export const usePutAddAdditionalDocuments = ({ onSuccess, onError, uuid }: Input) => {
  const putAddAdditionalDocuments = async (reqBody: AddAdditionalDocumentsRequest) => {
    await axiosClient.put<void>(
      PUT_ADD_ADDITIONAL_DOCUMENTS_PROFILE_AMENDMENT_REQUEST_URL(uuid),
      reqBody
    );
  };

  return useCustomMutation(putAddAdditionalDocuments, {
    onSuccess,
    onError,
  });
};
